@if (eventService.heroBlock$ | async) {
  <noda-events-header-bar
    [heroEvent]="eventService.heroBlock$ | async"
    [padding]="paddingRight"
  />
}

@switch (headerStatus()) {
  @case (enHeaderStatus.CONTACT_SALES) {
    <noda-contact-form-header />
  }
  @default {
    <noda-nav />
  }
}

<main [class.padding-top]="eventService.heroBlock$ | async">
  <router-outlet />
</main>

@if (!hideCartOnFormPage()) {
  <noda-cart />
}
@if (!isContactSalesPage()) {
  @if (footerStatus() | notEqual: enFooterStatus.NONE) {
    <div class="pre-footer-container">
      @switch (footerStatus()) {
        @case (enFooterStatus.NODA_PRIME) {
          <noda-pre-footer
            buttonText="Get Started"
            data-header-class="white"
            subtitle="TRY IT OUT"
            text="Join streamers already earning with Noda Prime. Create your donation page in 5 minutes and go live today"
            title="Level Up<br/>Your Stream"
            class="section"
          />
        }
        @case (enFooterStatus.QR_CODE_PAYMENTS) {
          <noda-pre-footer
            buttonText="Get Started"
            data-header-class="white"
            subtitle="LET’S GET IN TOUCH"
            text="We release hundreds of features and improvements every year to help you stay ahead of industry shifts and build a strong base for your business"
            title="Join Thousands of&nbsp;Businesses Growing with Noda"
            class="section"
          />
        }
        @case (enFooterStatus.PLUGINS_VIEW) {
          <noda-pre-footer
            buttonText="common.call-to-action.contact-team-btn"
            data-header-class="white"
            subtitle="common.footer.how-to-integrate"
            text="plugins.pre-footer.text"
            class="section"
            [title]="
              isSinglePluginPage()
                ? 'plugins.pre-footer.singlePageTitle'
                : 'plugins.pre-footer.mainTitle'
            "
          />
        }
        @case (enFooterStatus.ONLINE_GAMING_VIEW) {
          <noda-pre-footer
            id="gaming-experts"
            buttonText="Start conversation"
            data-header-class="white"
            subtitle="common.footer.lets-get-in-touch"
            title="Talk to our experts for a&nbsp;tailored Payment Solution"
            class="section online-gaming"
            [text]="null"
          />
        }
        @default {
          <noda-pre-footer
            buttonText="common.call-to-action.get-started"
            class="section"
            [attr.data-header-class]="
              footerThemeService.darkThemeEnabled() | condition: 'dark' : 'white'
            "
            [darkModeEnable]="footerThemeService.darkThemeEnabled()"
          />
        }
      }
      <noda-image-card
        *nodaResponsiveIf="[minWidthScreen.MD]"
        class="total-balance"
        [item]="
          footerThemeService.darkThemeEnabled()
            | condition: totalBalanceDarkImages : totalBalanceWhiteImages
        "
      />
    </div>
    <noda-footer
      [attr.data-header-class]="footerThemeService.darkThemeEnabled() | condition: 'dark' : 'white'"
      [darkModeEnable]="footerThemeService.darkThemeEnabled()"
    />
  }
}
